const TRIGGER_RATIO = 0.8;

function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
}

export function initPartnerTimelineAnimation() {
    const container = document.querySelector('.collectionPartner.isFullView .slidecontent');
    if (!container) return;

    const items = Array.from(container.querySelectorAll('.slidecontentItem'));
    if (!items.length) return;

    function updateProgress() {
        const triggerY = window.innerHeight * TRIGGER_RATIO;

        items.forEach((item, index) => {
            const nextItem = items[index + 1];
            if (!nextItem) return;

            if (nextItem.classList.contains('is-visible')) {
                item.style.setProperty('--line-progress', 1);
                return;
            }

            const dotY = nextItem.getBoundingClientRect().top + 9;
            const progress = clamp((window.innerHeight - dotY) / (window.innerHeight - triggerY), 0, 1);

            item.style.setProperty('--line-progress', progress);

            if (progress >= 1) {
                nextItem.classList.add('is-visible');
            }
        });
    }

    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
    updateProgress();
}
